import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '#environment';
import { DateUtils } from '~/shared/utils/date.utils';

@Component({
  selector: 'qvs-version-info',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss']
})
export class VersionInfoComponent {
  @Input() isEbanking = false;

  readonly version = environment.appVersion;
  readonly buildNumber = environment.appBuildNumber;
  readonly buildTime = DateUtils.format('MMMM YYYY', environment.buildDate);
  readonly debug = environment.debug;

  constructor() {}
}
